import * as THREE from "three";
import type {
  Dimension,
  Mat2,
  Mat3,
  MatrixValues,
  Vec3,
} from "@src/math/types";

const TRANSFORM_MATRIX = new THREE.Matrix4();
const TRANSFORMED_VECTOR = new THREE.Vector3();

export function transformVector(
  dimension: Dimension,
  matrix: Readonly<MatrixValues>,
  vector: Readonly<Vec3>,
): Vec3 {
  writeTransformationMatrix(TRANSFORM_MATRIX, dimension, matrix);
  TRANSFORMED_VECTOR.fromArray(vector).applyMatrix4(TRANSFORM_MATRIX);
  return [TRANSFORMED_VECTOR.x, TRANSFORMED_VECTOR.y, TRANSFORMED_VECTOR.z];
}

export function writeTransformationMatrix(
  result: THREE.Matrix4,
  dimension: Dimension,
  matrix: Readonly<MatrixValues>,
): THREE.Matrix4 {
  if (dimension === 2) {
    const m = matrix as Readonly<Mat2>;
    result.set(m[0], m[1], 0, 0, m[2], m[3], 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    return result;
  }

  const m = matrix as Readonly<Mat3>;
  result.set(
    m[0],
    m[1],
    m[2],
    0,
    m[3],
    m[4],
    m[5],
    0,
    m[6],
    m[7],
    m[8],
    0,
    0,
    0,
    0,
    1,
  );
  return result;
}
